import React, { useMemo } from 'react';
import Checkbox from './Checkbox';

const Accordion = React.memo(
  ({ category, items, isOpen, selectedIds, onToggle, onToggleAccordion }) => {
    const gridClass = useMemo(() => {
      if (category.id === 9) return 'list--grid prepared--food';
      if (category.id === 10) return 'list--grid maintanance--coffee-shop';
      return 'list--grid';
    }, [category.id]);

    const headerId = `category-header-${category.id}`;
    const panelId = `category-panel-${category.id}`;

    return (
      <div className={gridClass}>
        <button
          type="button"
          className="list--category--name"
          aria-expanded={isOpen}
          aria-controls={panelId}
          id={headerId}
          onClick={() => onToggleAccordion(category.id)}
        >
          {category.name}
        </button>
        {isOpen && (
          <div id={panelId} role="region" aria-labelledby={headerId}>
            {items.map((item) => (
              <Checkbox
                key={item.id}
                id={item.id}
                label={item.label}
                checked={selectedIds.has(item.id)}
                onChange={onToggle}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
);

Accordion.displayName = 'Accordion';

export default Accordion;
